import { CreateWithLinkedinProfile } from '../../OptionsViewV3/OptionCards/CreateWithLinkedinProfile'
import { CreateNewResume } from '../../OptionsViewV3/OptionCards/CreateNewResume'
import { CardContainer } from './styles'
import { UploadResumeCard } from './UploadResumeCard/UploadResumeCard'

interface Props {
  createResume: () => void
  linkedinResume: () => void
}
const OptionCards = ({ createResume, linkedinResume }: Props) => {
  return (
    <CardContainer>
      <UploadResumeCard />
      <CreateNewResume onClose={createResume} />
      <CreateWithLinkedinProfile onClose={linkedinResume} />
    </CardContainer>
  )
}

export default OptionCards
